import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { StripePricingTable } from "src/components/Payment/StripePricingTable";
import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";

export const PricingTableSection = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isFeatureActivated } = useApplicationParameters();
    const isPaymentEnabled = isFeatureActivated("FS-payment-enabled");

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: theme.spacing(3), mt: theme.spacing(4) }}>
            <Typography
                variant="h2"
                sx={{
                    fontSize: "24px",
                    fontWeight: 700,
                    fontFamily: "Montserrat",
                    color: "#393A36",
                }}
            >
                {t("companySettings.subscription.offers", "Offers & Pricing")}
            </Typography>
            <Box
                sx={{
                    backgroundColor: "white",
                    border: "1px solid #E0DEDD",
                    borderRadius: theme.spacing(2),
                    p: theme.spacing(4),
                    display: "flex",
                    flexDirection: "column",
                    gap: theme.spacing(4),
                }}
            >
                <StripePricingTable isPaymentFeatureEnabled={isPaymentEnabled} />
                {/* <PaymentPacksSection /> */}
            </Box>
        </Box>
    );
};
